import { faker } from '@faker-js/faker';

import type { LoginPostResponse } from '../types/LoginPostResponse';

export function createLoginPostResponse(
  data: NonNullable<Partial<LoginPostResponse>> = {}
): NonNullable<LoginPostResponse> {
  return {
    ...{
      data: {
        AuthenticationResult: {
          AccessToken: faker.string.alpha(),
          IdToken: faker.string.alpha(),
          RefreshToken: faker.string.alpha(),
        },
        ChallengeName: faker.string.alpha(),
        ChallengeParameters: {},
        SecretCode: faker.string.alpha(),
        Session: faker.string.alpha(),
      },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
